import type { Transition } from "@uirouter/react";
import type { RedirectToResult } from "@uirouter/react";

import {
    WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW,
    WEBSITE_ANALYSIS_ROOT,
} from "app/pages/sales-intelligence/constants/routes";
import { FiltersEnum } from "app/components/filters-bar/utils";
import { SocialOverviewPage } from "app/pages/digital-marketing/social/SocialOverviewPage";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";
import { filterConsistencyParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { onRedirectWebsiteAnalysis } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectWebsiteAnalysis";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const SOCIAL_GROUP_CONFIG: Record<
    string,
    IRouterState & { isPdfDownloadButton?: boolean; pdfDownloadsMethod?: () => Promise<any> }
> = {
    [WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW]: {
        stateId: WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW,
        parent: WEBSITE_ANALYSIS_ROOT,
        url: "/social/overview/:key/:isWWW/:country/:duration?selectedTab&social_filters&webSource&source",
        component: SocialOverviewPage,
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "traffic",
            subSubSection: "social",
        },
        trackingId: {
            section: "Account Review",
            subSection: "social",
            subSubSection: "socialOverview",
        },
        pageTitle: "analysis.social.overview.title",
        isUSStatesSupported: true,
        reloadOnSearch: false,
        homeState: "salesIntelligence-home",
        redirectTo: redirectPipe(onRedirectWebsiteAnalysis()) as (transition: Transition) => RedirectToResult,
        data: {
            filtersConfig: {
                webSource: FiltersEnum.DISABLED,
            },
        },
        params: {
            ...filterConsistencyParams,
        },
        defaultQueryParams: {
            webSource: "Desktop",
            duration: "3m",
            country: 999,
            isWWW: "*",
        },
    },
};
